module.exports = __webpack_public_path__ + "static/surco-f8aadf7353cbad64858fc3ee5fd23842.jpg";